import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "filter__title" }, "Фильтры", -1)
const _hoisted_3 = { class: "filter__block" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "hr" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_aviacompany = _resolveComponent("filter-aviacompany")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_filter_airport_from = _resolveComponent("filter-airport-from")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_filter_airport_to = _resolveComponent("filter-airport-to")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Accordion, {
        multiple: true,
        activeIndex: [0]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, { header: "Авикомпании" }, {
            default: _withCtx(() => [
              _createVNode(_component_filter_aviacompany, {
                filterByCompany: _ctx.filterByCompany,
                acceptFilterAirlines: _ctx.acceptFilterAirlines
              }, null, 8, ["filterByCompany", "acceptFilterAirlines"])
            ]),
            _: 1
          }),
          _createVNode(_component_AccordionTab, { header: "Аэропорт" }, {
            default: _withCtx(() => [
              _createVNode(_component_TabView, null, {
                default: _withCtx(() => [
                  _createVNode(_component_TabPanel, { header: "Вылета" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_filter_airport_from, {
                        acceptFilterAirportFrom: _ctx.acceptFilterAirportFrom,
                        filterByAirportFrom: _ctx.filterByAirportFrom
                      }, null, 8, ["acceptFilterAirportFrom", "filterByAirportFrom"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_TabPanel, { header: "Прилета" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_filter_airport_to, {
                        acceptFilterAirportTo: _ctx.acceptFilterAirportTo,
                        filterByAirportTo: _ctx.filterByAirportTo
                      }, null, 8, ["acceptFilterAirportTo", "filterByAirportTo"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createVNode("button", {
      type: "button",
      class: "submit-button",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.acceptFilter(...args)), ["prevent"]))
    }, " Применить ")
  ]))
}